import { DEFAULT_PLACEHOLDER } from '@constants/generic';
import { AddToMode, SubmissionPaymentStatus } from '@features/forms/types';
import { formatISODate } from '@utils/date';

const SUBMISSION_PAYMENT_STATUS_LABELS: Record<
  SubmissionPaymentStatus,
  string
> = {
  paid: 'Paid',
  processing: 'Processing'
};

export const formatSubmissionPaymentStatusLabel = (
  status: SubmissionPaymentStatus
): string => SUBMISSION_PAYMENT_STATUS_LABELS[status];

export const formatSubmissionPaidOn = (paidAt: string): string =>
  paidAt
    ? formatISODate({ date: paidAt, separator: '/', format: 'dd-mm-yyyy' })
    : DEFAULT_PLACEHOLDER;

export const formatSubmissionVersion = (version: number): string =>
  `V${version}`;

export const formatSubmissionAddedTo = (addedTo: {
  mode: AddToMode;
  groupName?: string;
}): string => {
  if (addedTo.mode === 'member_list') {
    return 'Member list';
  }
  return addedTo.groupName ?? DEFAULT_PLACEHOLDER;
};

export const formatSubmissionMobile = (phone: string): string => {
  if (!phone) {
    return DEFAULT_PLACEHOLDER;
  }
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) {
    return `+91 ${digits.slice(2)}`;
  }
  if (digits.length === 10) {
    return `+91 ${digits}`;
  }
  return phone;
};
